module.exports = __webpack_public_path__ + "static/media/logo-althar-blanco.63aaa224.png";